import { Helmet } from '@slorber/react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Bienvenue à Licorne Academy',
  description: 'Chez Licorne Academy , On vend les meilleures formations',
  keywords: 'formation présentielle, formation en ligne',
};

export default Meta;
